import {createContext, useContext} from "react";


export type ErrorHandler = (error: Error) => void;

const Context = createContext<ErrorHandler>(null);


export const ErrorHandlerProvider = Context.Provider;


export function useErrorHandler() {
    const errorHandler = useContext(Context);
    if (!errorHandler) {
        throw new Error("Missing ErrorHandlerProvider");
    }
    return errorHandler;
}